import { render, staticRenderFns } from "./AddGroupNumber2023.vue?vue&type=template&id=04931210&scoped=true"
import script from "./AddGroupNumber2023.vue?vue&type=script&lang=js"
export * from "./AddGroupNumber2023.vue?vue&type=script&lang=js"
import style0 from "./AddGroupNumber2023.vue?vue&type=style&index=0&id=04931210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04931210",
  null
  
)

export default component.exports